import React from 'react';

const COLORS = {
  primary: 'bg-primary/10 text-primary-dark border-primary/20 dark:bg-primary/15 dark:text-accent dark:border-primary/30',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/30',
  warning: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/30',
  danger: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/30',
  gray: 'bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600'
};

const Badge = ({ color = 'gray', children, className = '' }) => (
  <span className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold border whitespace-nowrap ${COLORS[color] || COLORS.gray} ${className}`}>
    {children}
  </span>
);

export default Badge;
